import React from 'react';

// Affichage unifié d'une personne : NOM (gras, capitales) puis prénom.
// `order="fn"` inverse (prénom puis NOM) — le nom garde sa graisse dans les
// deux sens : c'est lui qu'on cherche des yeux.
export default function PersonName({ firstName, lastName, order = 'ln' }) {
  if (!firstName && !lastName) return <>—</>;
  const last = lastName ? <strong>{String(lastName).toUpperCase()}</strong> : null;
  const sep = lastName && firstName ? ' ' : '';
  if (order === 'fn') {
    return <>{firstName || ''}{sep}{last}</>;
  }
  return <>{last}{sep}{firstName || ''}</>;
}
